<c-card *ngIf="monitor">
  <c-card-body *transloco="let t" class="px-2">


          <c-row>
            <c-col md="12" lg="6">
                <h3>{{ t('Update') }} {{monitor.name}}</h3>
            </c-col>
            <c-col md="12" lg="6" class="text-end mb-2">

              <div class="btn-group mb-2 " role="group">
              <button color="light" cButton  routerLink="/mgmt/monitors/monitors">
                  <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                  {{ t('Return to Monitors') }}
              </button>
              <a href="https://okalone.zendesk.com/hc/en-gb/categories/35344534733713-Monitors" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
              <button cButton class="my-2" color="danger" class="text-white" (click)="doDelete()" *ngIf="okService.hasMonitorAccess('monitors','delete')">
                <i class="fa-solid fa-x"></i> {{ t('Delete') }}
              </button>
              </div>

            </c-col>
          </c-row>

        <c-row class="justify-content-left">
          <c-col>


                    <div class="row">
                      <div class="col-md-6">


                        <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Name') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'name'"
                              cFormControl
                              placeholder="{{ t('Name') }}"
                              [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('A suitable name for this monitor')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['name'].errors" class="invalid-feedback">
                                {{ t('A valid name is required": "A valid name is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilEnvelopeClosed"></svg> {{ t('Email') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'email'"
                              cFormControl
                              placeholder="{{ t('Email') }}"
                              [ngClass]="{ 'border-danger': submitted && f['email'].errors }"
                              [attr.disabled]="monitor.fa2 && monitor.email"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for email alerts')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                                {{ t('A valid email is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilMobile"></svg> {{ t('Cell Number') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone'"
                              cFormControl
                              placeholder="{{ t('For Text Messages') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone'].errors }"
                              [attr.disabled]="monitor.fa2 && monitor.phone"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for SMS alerts - please use the international code such as +44 for UK, or +1 for Canada. Can be the same as the Phone Number.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone'].errors" class="invalid-feedback">
                                {{ t('A valid phone number is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Phone Number') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone2'"
                              cFormControl
                              placeholder="{{ t('For Phone Calls') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone2'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for phone call alerts - please use the international code such as +44 for UK, or +1 for Canada. Can be the same as the Cell Number.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone2'].errors" class="invalid-feedback">
                                {{ t('A valid phone number is required') }}
                            </div>
                          </div>
                        </div>

                        <ng-container *ngIf="okService.settings.international && okService.isAdmin()">


                          <div class="form-group row mb-2" >
                            <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilLocationPin"></svg> {{ t('Country') }}</label>
                            <div class="col-8">
                              <ng-select [items]="countryListArray"
                              bindLabel="name"
                              bindValue="code"
                              formControlName="country"
                              placeholder="{{ t('Country') }}">
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The country of the monitor, required if they are in another country to the account country')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>

                          <div class="form-group row mb-2" >
                            <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-globe"></i> {{ t('Timezone') }}</label>
                            <div class="col-8">
                              <ng-select [items]="timezoneListArray"
                                        bindLabel="name"
                                        bindValue="tzCode"
                                        formControlName="timezone"
                                        placeholder="{{ t('Timezone') }}">
                              </ng-select>
                              <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The timezone of the monitor, required if they are in another timezone to the account timezone')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>


                        </ng-container>

                        <b></b>

                        <div class="form-group row mb-2">
                          <label class="col-4 col-form-label text-start text-sm-end">{{ t('Contact Method:') }}</label>
                          <div class="col-6">
                            <div class="row">
                              <div class="col-6">
                                <input class="form-check-input" type="checkbox" id="use_email" name="use_email"  formControlName="use_email">
                                <label class="form-check-label" for="use_email">
                                  &nbsp; &nbsp;{{ t('Email') }}
                                </label>
                              </div>
                              <div class="col-6" *ngIf="monitor.country!='NZ'">
                                <input class="form-check-input" type="checkbox" id="use_sms" name="use_sms"  formControlName="use_sms">
                                <label class="form-check-label" for="use_sms">
                                  &nbsp; &nbsp;{{ t('SMS') }}
                                </label>
                              </div>
                              <div class="col-6">
                                <input class="form-check-input" type="checkbox" id="use_phone" name="use_phone"  formControlName="use_phone">
                                <label class="form-check-label" for="use_phone">
                                  &nbsp; &nbsp;{{ t('Phone') }}
                                </label>
                              </div>
                              @if(okService.hasFeature('whatsapp')) {
                              <div class="col-6">
                                <input class="form-check-input" type="checkbox" id="use_whatsapp" name="use_whatsapp"  formControlName="use_whatsapp">
                                <label class="form-check-label" for="use_whatsapp">
                                  &nbsp; &nbsp;{{ t('WhatsApp') }}
                                </label>
                              </div>
                              }
                            </div>

                          </div>
                        <div class="col-2 text-center">
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose the method to contact the monitor, if none is chosen email will be used. SMS is not available in New Zealand at this time.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        </div>
                        </div>
                        

                        <ng-container *ngIf="okService.hasFeature('access') && okService.isAdmin()">

                        <div class="form-group row mb-2">
                          <label for="admin" class="col-4 col-form-label text-start text-sm-end">{{ t('Admin Access') }}</label>
                          <div class="col-8">
                            <div class="row">

                              <ng-select id="admin" name="admin" formControlName="admin" [readonly]="formGroup.value['privacy']==true">
                                <ng-option [value]="true">{{ t('Yes') }}</ng-option>
                                <ng-option [value]="false">{{ t('No') }}</ng-option>
                              </ng-select>
                              <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('Admin Access has access to accounts, settings and can edit all users including change admin access.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>
                        </div>
                        <div class="row my-1" *ngIf="formGroup.value['privacy']==true">
                          <div class="col-12">
                            <i class="fas fa-info-circle text-info"></i> {{ t('If Extended Privacy is selected, the monitor cannot be an Admin') }}
                          </div>
                        </div>

                        <div class="form-group row mb-2" *ngIf="formGroup.value['admin']==false || formGroup.value['admin']=='false'">
                          <label for="privacy" class="col-4 col-form-label text-start text-sm-end">{{ t('Extended Privacy') }}</label>
                          <div class="col-8">
                            <ng-select id="privacy" name="privacy" formControlName="privacy">
                              <ng-option [value]="true">{{ t('Yes') }}</ng-option>
                              <ng-option [value]="false">{{ t('No') }}</ng-option>
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('If selected this option only allows the monitor to view workers they are assigned to, all other workers are hidden from view. https://okalone.zendesk.com/hc/en-gb/articles/35907369502481-How-to-Set-up-Extended-Privacy-for-Monitors')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          </div>
                        </div>


                        <div class="form-group row mb-2" *ngIf="okService.settings.fa2">
                          <label for="fa2" class="col-4 col-form-label text-start text-sm-end">{{ t('Multi-Factor Authentication') }}</label>
                          <div class="col-8">
                            <select class="form-control" id="fa2" name="fa2" formControlName="fa2" [attr.disabled]="(!monitor.phone || !formGroup.value['phone']) ? '' : null">
                              <option [ngValue]="true">{{ t('Yes') }}</option>
                              <option [ngValue]="false">{{ t('No') }}</option>
                            </select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('This monitor will need to enter an OTP (One-Time-Password) for Multi-Factor Authentication when logging in to the dashboard.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button> <br/>

                            <div class="alert alert-warning m-1 p-1" role="alert" *ngIf="!monitor.fa2 && formGroup.value['fa2']">
                              <p ><i class="fas fa-exclamation-triangle text-warning"></i> {{ t("Please double-check that the phone number and/or email is correct.")}} <br/><b>{{ t("Cell Number: ")}}{{monitor.phone}}</b><br/><b>{{ t("Email:")}}&nbsp;{{monitor.email}}</b></p>
                            </div>
                          </div>
                        </div>

                      </ng-container>

                      <button cButton class="px-4 mb-2 text-white btn-info" type="submit" *ngIf="this.okService.isAdmin() || this.okService.hasMonitorAccess('monitors','update')">
                        <i class="fa-solid fa-check"></i> {{ t('Update the Monitor') }}
                      </button>

                    </form>

                      </div>
                      <div class="col-md-6">

                        <button type="button" class="btn btn-outline-dark fs-4 mb-2" (click)="sendWelcome()">
                          <i class="fa-solid fa-paper-plane fa-2x"></i> {{ t('Send Welcome Email') }}
                        </button>

                        <ng-container *ngIf="okService.isAdmin()">

                        <form [formGroup]="passFormGroup" cForm (ngSubmit)="submitPassForm()" class="info-form">

                        <br/><br/>
                        <div class="card"  *ngIf="!okService.isAdp()">
                          <div class="card-header">
                            <b>{{ t('Change Password') }}</b>
                          </div>
                          <div class="card-body">
                            <div class="form-group row mb-2" >
                              <label class="col-4 col-form-label text-start text-sm-end">{{ t('Password') }}</label>
                              <div class="col-8">
                                <input
                                  [formControlName]="'password'"
                                  cFormControl
                                  placeholder="{{ t('Enter new password to change it') }}"
                                  [ngClass]="{ 'border-danger': passSubmitted && pf['password'].errors }"
                                />
                                <div *ngIf="passSubmitted && (pf['password'].errors || password_error)" class="invalid-feedback">
                                    {{ t('Password should be at least 8 characters in length and should include at least one upper case letter, one number, and one special character.') }}
                                </div>
                              </div>
                            </div>
                            <button  class="btn btn-outline-primary" type="submit">
                              <i class="fa-solid fa-check"></i> {{ t('Update Password') }}
                            </button>
                          </div>
                        </div>

                        </form>

                      </ng-container>

                        <br/><br/>

                        <ng-container *ngIf="okService.isAdmin()">


                        <form [formGroup]="teamsUrlGroup" cForm (ngSubmit)="submitTeamsUrl()" class="info-form">
                          <div class="card" *ngIf="okService.hasFeature('teams_notifications')">
                            <div class="card-header">
                              <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353012415377-Get-Alerts-in-a-Microsoft-Teams-Channel" class="btn btn-primary btn-sm float-end" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Learn More') }}</a>
                              <b>{{ t('Teams Notification Channel Webhook') }}</b>
                            </div>
                            <div class="card-body">
                              <div class="form-group row mb-2" >
                                <label class="col-4 col-form-label text-start text-sm-end">{{ t('Channel Webhook URL') }}</label>
                                <div class="col-8">
                                  <input
                                    [formControlName]="'teams_webhook_url'"
                                    cFormControl
                                    placeholder="{{ t('Enter your Teams Channel Webhook URL') }}"
                                    [ngClass]="{ 'border-danger': teamsUrlSubmitted && pf['teams_webhook_url'].errors }"
                                  />
                                  <div *ngIf="teamsUrlSubmitted && (tf['teams_webhook_url'].errors || teams_webhook_url_error)" class="invalid-feedback">
                                      {{ t('Please input the webhook URL for the Teams Channel in which you would like to receive Alert Notifications.') }}
                                  </div>
                                </div>
                              </div>
                              <button  class="btn btn-outline-primary" type="submit">
                                <i class="fa-solid fa-check"></i> {{ t('Update Teams Channel Webhook') }}
                              </button>
                            </div>
                          </div>
                        </form>

                      </ng-container>

                      <!-- Only show if the monitor is not and admin and if the user is an admin and from OK Alone -->
                      <!-- Temporary update to allow Jessica update while we migrate to new user roles -->
                      <ng-container *ngIf="okService.isOkAloneAdmin() || okService.session?.email == 'jessica.walden@fdc.myflorida.com'">
                        <br/><br/>
                        <app-monitor-access-controls [monitor]="monitor"></app-monitor-access-controls>
                      </ng-container>
                      </div>
                    </div>


          </c-col>
        </c-row>

  </c-card-body>
</c-card>
